module.exports = __webpack_public_path__ + "img/title-2.247b92a4.png";